import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { ApiService } from '../../../../services/api/api.service';
import { NbToastrService } from '@nebular/theme';

@Component({
	selector: 'bulk-hierarchy',
	templateUrl: './bulk-hierarchy.component.html',
	styleUrls: ['./bulk-hierarchy.component.css']
})
export class BulkHierarchyComponent implements OnInit {
	private requisitionId: any;
	private requisitionPartialId: any;
	public loading: boolean;
	public items: any;
	public comments: any;
	public warehouses: any;
	public suppliers: any;
	public hierarchies: any;
	public nonFilteredSuppliers: any;
	public _globalSupplierId: any;
	public _globalHierarchyId: any;
	public _globalWarehouseId: any;
	public requisition: any;
	public isSiv: boolean;
	public get globalSupplierId() {
		return this._globalSupplierId;
	}
	public set globalSupplierId(value) {
		this._globalSupplierId = value;
		if (value) {
			this.items.forEach(i => {
				i.supplierId = value;
				i.warehouseId = null;
				i.inStock = false;
			})
		}
	}
	public get globalHierarchyId() {
		return this._globalHierarchyId;
	}
	public set globalHierarchyId(value) {
		this._globalHierarchyId = value;
		if (value) {
			this.items.forEach(i => {
				if (this.requiresHierarchy(i))
					i.hierarchyId = value;
			})
		}
	}
	public get globalWarehouseId() {
		return this._globalWarehouseId;
	}
	public set globalWarehouseId(value) {
		this._globalWarehouseId = value;
		if (value) {
			this.items.forEach(i => {
				i.warehouseId = value;
				i.inStock = true;
				i.supplierId = null;
			})
		}
	}
	constructor(public config: DynamicDialogConfig, public ref: DynamicDialogRef,
		private apiService: ApiService,
		private messageService?: NbToastrService) {
		if (config && config.data && config.data.requisitionId) {
			this.requisitionId = config.data.requisitionId;
			this.requisition = config.data.requisition;
			this.isSiv = config.data.siv;
			if (this.isSiv)
				this.comments = "Update #SIV"
			this.loadLookups();
			this.loadItems();
		}



	}

	ngOnInit() {
		this.apiService.get(`/api/hierarchy`)
			.subscribe(results => {
				this.hierarchies = results.map(o => {
					return { label: o.code + " - " + o.description, value: o.id }
				})
			});

		this.apiService.get(`/api/supplier/searchAuto`)
			.subscribe(results => {
				this.suppliers = results.map(o => {
					return { label: o.name, value: o.id }
				})
				this.nonFilteredSuppliers = results.map(o => {
					return { label: o.name, value: o.id }
				})
			});

		this.apiService.get(`/api/warehouse`)
			.subscribe(results => {
				this.warehouses = results.map(o => {
					return { label: o.name, value: o.id }
				})
			});
	}

	public loadLookups() {

	}

	public requiresHierarchy(item) {
		if (item.generalLedgerId)
			return false;
		if (this.requisition.isStore || this.requisition.isPettyCash)
			return false;
		return true;
	}

	public loadItems() {
		this.loading = true;

		this.items = new Array();
		this.apiService.get(`/api/requisitionItem/getRequisitionItemsForReq/${this.requisitionId}`)
			.subscribe(results => {
				this.items = results;
				this.loading = false;

				if (results.length == 0)
					this.ref.close();
			}, err => {
				this.messageService.danger("Could not load", "Action");
				this.loading = false;
			});
	}


	public send() {
		if (this.comments == null || this.comments == "") {
			return;
		}
		this.loading = true;
		this.items.forEach(o => {
			if (o.inStock)
				o.supplierId = null;
			else o.warehouseId = null;
		})
		this.apiService.post(`/api/requisitionItem/bulkUpdate`, { items: this.items, comment: this.comments })
			.subscribe(results => {
				this.loading = false;
				this.messageService.success("Updated successfully", "Action");
				this.ref.close(true);
			}, err => {
				this.messageService.danger("Could not load", "Action");
				this.loading = false;
			});
	}

	public complete() {
		if (this.comments == null || this.comments == "") {
			return;
		}
		this.loading = true;
		this.apiService.post(`/api/requisitionItem/bulkSIV`, { items: this.items, comment: this.comments })
			.subscribe(results => {
				this.loading = false;
				this.messageService.success("Completed successfully", "Action");
				this.ref.close(true);
			}, err => {
				this.messageService.danger("Could not load", "Action");
				this.loading = false;
			});
	}

	public cancel() {
		this.ref.close();
	}

	handleFilter(value) {
		this.suppliers = this.nonFilteredSuppliers.filter((s) => s.label.toLowerCase().indexOf(value.toLowerCase()) !== -1);
	}
	public inStockChange(e, item) {

	}
}
